export default "__VITE_ASSET__D4aHVjx5__"